import { render, staticRenderFns } from "./ReporteEmisionAsistenciasVigor.vue?vue&type=template&id=2fabc866"
import script from "./ReporteEmisionAsistenciasVigor.vue?vue&type=script&lang=js"
export * from "./ReporteEmisionAsistenciasVigor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports